import React from "react";
import { Circle, Tooltip } from "react-leaflet";

const RouteControlPoints = React.memo(({ routeControlPoints }) => {
    return (routeControlPoints || []).map((el, index) => <RouteControlPoint key={index} item={el} />);
});

const RouteControlPoint = (props) => {
    const { item } = props;

    // Support both geozone.location.coordinates format (from GetPoints)
    // and direct location array format (from roadControlPoints in GetRoute)
    let position;
    if (item.geozone?.location?.coordinates) {
        position = [...item.geozone.location.coordinates].reverse();
    } else if (item.location && Array.isArray(item.location)) {
        position = [...item.location].reverse();
    } else {
        return null;
    }

    const radius = item.geozone?.radius ?? item.radius ?? 200;
    const name = item.name;
    const comment = item.comment;

    return (
        <>
            <Circle center={position} radius={radius} color="#f59e0b">
                <Tooltip direction="top">
                    <div className="font-weight-bold">{name}</div>
                    {comment && <div>{comment}</div>}
                </Tooltip>
            </Circle>
        </>
    );
};

const MemoizedRouteControlPoints = (props) => <RouteControlPoints {...props} />;

export default MemoizedRouteControlPoints;
